import { siteConfig } from '@/config/site';
import { useLanguage } from '@/context/LanguageContext';
import ContactActionButtons from './ContactActionButtons';

export function HeroSection() {
  const { language } = useLanguage();
  const content = siteConfig.content[language].hero;

  return (
    <section className="relative min-h-[90vh] flex items-center justify-center pt-20 overflow-hidden" data-testid="hero-section">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[#07060B]">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-radial-pink opacity-30 blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-radial-cyan opacity-20 blur-3xl" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-16">
        {/* Logo Image - Clean with bright glow */}
        <div className="flex justify-center mb-6">
          <div className="relative animate-breathe">
            <div className="absolute inset-0 -m-12 bg-gradient-radial from-[#8B5CFF]/30 via-transparent to-transparent blur-xl" />
            <img 
              src={siteConfig.brand.logoUrl} 
              alt="Casa de Candy"
              className="w-96 sm:w-[28rem] md:w-[32rem] h-auto object-contain relative z-10"
              style={{
                filter: 'drop-shadow(0 0 20px rgba(139, 92, 255, 0.8)) drop-shadow(0 0 40px rgba(255, 77, 166, 0.5)) drop-shadow(0 0 60px rgba(39, 215, 255, 0.3))'
              }}
              data-testid="hero-logo"
            />
          </div>
        </div>

        {/* Subtitle */}
        <p className="font-heading text-xl sm:text-2xl md:text-3xl text-[#A7A3BA] font-light tracking-wide mb-6">
          {content.subtitle}
        </p>

        {/* Description */}
        <p className="text-[#A7A3BA] text-base sm:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          {content.description}
        </p>

        {/* CTA Buttons - Using ContactActionButtons component */}
        <div className="flex justify-center" data-testid="hero-cta-buttons">
          <ContactActionButtons variant="hero" showWhatsApp={true} />
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
